import { render, staticRenderFns } from "./CbsConstructorChainWizard.vue?vue&type=template&id=0c5b28d0&scoped=true"
import script from "./CbsConstructorChainWizard.vue?vue&type=script&lang=js"
export * from "./CbsConstructorChainWizard.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructorChainWizard.vue?vue&type=style&index=0&id=0c5b28d0&prod&lang=scss&scoped=true"
import style1 from "./CbsConstructorChainWizard.vue?vue&type=style&index=1&id=0c5b28d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b28d0",
  null
  
)

export default component.exports